import { useNotificationStore } from "./store";
import { NotificationStateModel } from "./store";

export const useNotificationState = (): NotificationStateModel =>
  useNotificationStore();
